import { useAuthStore } from '@/stores/auth'
import { useFormStore } from '@/stores/form'
import { DateTime } from 'luxon'
import { defineStore } from 'pinia'
import { computed } from 'vue'
import router from '@/router'

export const usePreloadStore = defineStore('preloadStore', () => {
  const authStore = useAuthStore()
  const formStore = useFormStore()

  const reports = computed(() => {
    return [
      {
        label: 'statisticalRequestsForCompanies',
        reasonId: 1001
      },
      {
        label: 'usersKPIs',
        reasonId: 1002
      },
      {
        label: 'essentialSummaryCharts',
        reasonId: 1003
      }
    ]
  })

  const prepareForm = async () => {
    if (!authStore.establishmentInfo) {
      await authStore.fetchEstablishmentInfo()
    }

    const route = router.currentRoute.value
    const { reasonId } = route.query

    const now = DateTime.now()

    if (reasonId) {
      formStore.form.setFieldValue(
        'nameOfReport',
        reports.value.find((r) => r.reasonId == reasonId).label
      )
    }

    formStore.form.setValues({
      startingDate: now.minus({ months: 1 }).toISODate(),
      EndingDate: now.toISODate(),
    })
  }

  const getters = { reports }
  const actions = { prepareForm }

  return {
    ...getters,
    ...actions
  }
})

export default async function () {
  const preloadStore = usePreloadStore()
  return await preloadStore.prepareForm()
}
